import { render } from "./TaggedMarkdown.vue?vue&type=template&id=7ae5c5f0&ts=true"
import script from "./TaggedMarkdown.vue?vue&type=script&lang=ts"
export * from "./TaggedMarkdown.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__